import { render, staticRenderFns } from "./BidvestBankForm.vue?vue&type=template&id=779c0716"
import script from "./BidvestBankForm.vue?vue&type=script&lang=js"
export * from "./BidvestBankForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports